import { render, staticRenderFns } from "./CongratulationBlock.vue?vue&type=template&id=56c727f2&scoped=true&"
import script from "./CongratulationBlock.vue?vue&type=script&lang=js&"
export * from "./CongratulationBlock.vue?vue&type=script&lang=js&"
import style0 from "./CongratulationBlock.vue?vue&type=style&index=0&id=56c727f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c727f2",
  null
  
)

export default component.exports